// Module Import
//---------------------------------
import React, { useState } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby-link'
import TypographyAtom from '../../atoms/typography/typography'
import ArrowIcon from '../../../assets/images/icon_simplified_arrow.svg'
import ButtonAtom from '../../atoms/buttons/buttons'
import {
  brandIvory,
  brandOrange,
  brandSlate,
  brandSoftGrey,
  brandSoftOrange,
} from '../../../assets/consts/color'
import { secondaryFont } from '../../../assets/consts/fonts'
import Loader from '../../atoms/loader/Loader'
import useStore from '../../../context/StoreContext'
import getFormattedPrice from '../../../helpers/getFormattedPrice'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const AccordionWrapper = styled.div`
  //background: ${brandIvory};
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

const AccordionHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 48px;
  justify-content: space-between;
  padding: 24px 16px;
  width: 100%;
  background: ${brandIvory};

  cursor: pointer;
  user-select: none;

  H5 {
    font-family: 'Poppins';
    font-weight: 400;
    line-height: 120%;
    color: ${brandSlate};
    margin: 0;
  }

  /* &:hover {
    color: ${brandOrange};
    background-color: ${brandSoftOrange};
    border-color: transparent;
  } */
`

const AccordionBody = styled.div`
  display: grid;
  gap: 8px;
`

const Icon = styled.div`
  height: 24px;
  width: 24px;

  display: grid;
  place-content: center;

  transition: all 0.1s ease-in-out;
  ${({ opened }) =>
    opened
      ? `
        transform: rotate(0);
    `
      : `transform: rotate(-90deg);`}

  img {
    width: 12px;
    height: 9px;
  }
`

const closed = {
  display: 'none',
}

const open = {
  display: 'block',
}

const ProductList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const ProductWrapper = styled.div`
  display: flex;
  align-content: center;
  /* justify-content: space-between; */
  flex-direction: row;
  gap: 8px;
`

const ProductImage = styled.img`
  width: 60px;
  max-width: 60px;
  padding: 0;

  object-fit: contain;

  @media (min-width: 768px) {
    width: 100px;
    max-width: 100px;
  }
`

const ProductInformation = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-start;
  flex-grow: 1;
  padding: 16px;
  min-width: 105px;

  width: clamp(100px, 100%, 500px);
  background: ${brandIvory};
`

const ProductTitle = styled.p`
  margin: 0;
  text-align: start;
`

const ProductLink = styled(Link)`
  width: 100%;
  text-decoration: none;
  border-bottom: none;
  font-weight: normal;

  font-size: 16px;

  color: ${brandSoftGrey};
  font-family: ${secondaryFont};
  line-height: 120%;
  //opacity: 75%;

  &:visited {
    color: ${brandSoftGrey};
  }

  &:hover {
    color: ${brandOrange};
    opacity: 1;
  }

  @media (min-width: 768px) {
    font-size: clamp(19px, 1vw, 24px);
  }
`

const ProductPrice = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;
  flex: 0 0 auto;

  font-size: 12px;
  text-align: start;

  span {
    color: ${brandOrange};
  }

  @media (min-width: 768px) {
    font-size: 14px;
  }
`

const ProductButton = styled.p`
  position: relative;
  margin: 0;
  padding: 16px;

  //width: 200px;
  flex-shrink: 0;
  align-content: center;
  background: ${brandIvory};

  @media (max-width: 768px) {
    //width: 130px;
  }

  button,
  a {
    cursor: pointer;
    width: 200px;
    height: 56px;
    text-align: center;
    //display: grid;
    //place-content: center;
    line-height: 1.15;

    &:active:hover {
      background-color: ${brandSoftOrange};
    }

    /* &:focus:hover {
      background-color: ${brandSoftOrange};
    } */

    /* width: 100%; */
    @media (max-width: 768px) {
      width: 130px;
      height: 50px;
      display: grid;
      place-content: center;
      text-wrap: wrap;

      &:after {
        display: none;
      }
    }
  }

  button:disabled {
    opacity: 0.5;
    cursor: auto;

    user-select: none;
    pointer-events: none;
  }

  ${({ disabled }) =>
    disabled &&
    `
        user-select: none;

        button:disabled {
          cursor: auto;
          background-color: ${brandSoftOrange};
        }
        
         button:after {
          display: none;
        }
        
        button:active:hover {
          background: ${brandSoftOrange};
        }
        
    `}
`

// Component Export
//---------------------------------
export default function AccordionRental({ header, products, onAction, isLoading }) {
  const [accordionStatus, setaccordionStatus] = useState('false')
  const { currentMarket } = useStore()

  const openAccordion = () => {
    setaccordionStatus(!accordionStatus)
  }

  const getProductPrice = (price) => (price && !Number.isNaN(price) ? Number(price).toFixed(2) : 0)

  function ItemButton({ product }) {
    if (isLoading) {
      return <Loader />
    }

    return (
      <>
        {product.isAvailable
          ? product.inCart
            ? 'Remove from cart'
            : 'Add to cart'
          : 'Unavailable'}
      </>
    )
  }

  return (
    <AccordionWrapper>
      <AccordionHeader
        onClick={() => {
          openAccordion()
        }}
      >
        <TypographyAtom type="H5" copy={header} weight="Bold" />
        <Icon opened={!accordionStatus}>
          <img src={ArrowIcon} alt="" />
        </Icon>
      </AccordionHeader>
      <AccordionBody style={accordionStatus ? closed : open}>
        <ProductList>
          {products.map((product) => (
            <ProductWrapper key={product.handle}>
              <ProductImage
                src={product?.featuredImage?.url}
                alt={product?.featuredImage?.altText}
              />
              <ProductInformation>
                <ProductTitle>
                  <ProductLink to={`/products/${product.handle}`} target="_blank">
                    {product.title}
                  </ProductLink>
                </ProductTitle>

                <ProductPrice>
                  <span>
                    {isLoading ? (
                      <Loader size="16px" />
                    ) : (
                      getFormattedPrice({
                        currentMarket,
                        price: getProductPrice(product.priceRange?.maxVariantPrice?.amount),
                      })
                    )}
                  </span>{' '}
                  per week
                </ProductPrice>
              </ProductInformation>
              <ProductButton disabled={!product.isAvailable}>
                <ButtonAtom
                  buttonCopy={<ItemButton product={product} />}
                  buttonType="Primary Button"
                  onClick={() => {
                    onAction(product.handle)
                  }}
                  disabled={!product.isAvailable}
                />
              </ProductButton>
            </ProductWrapper>
          ))}
        </ProductList>
      </AccordionBody>
    </AccordionWrapper>
  )
}

AccordionRental.propTypes = {}
